// extracted by mini-css-extract-plugin
export default {"cls1":"News-cls1_TGq","cls2":"News-cls2_y7x News-cls1_TGq"};